module.exports = __webpack_public_path__ + "static/media/cloud-hail.493adfb1.svg";